
import { Component, Vue } from 'vue-property-decorator';
import ChatEscalation from '@/views/pages/qa/escalation/ChatEscalation.vue';
import { EscalationRepositoryInterface } from '@/services/QA/escalation/interfaces';
import TicketEscalation from '@/views/pages/qa/escalation/TicketEscalation.vue';

@Component({
  components: {
    ChatEscalation,
    TicketEscalation,
  },
  inject: [
    'escalationRepository',
  ],
})
export default class ViewEscalation extends Vue {
  private loading: boolean = true;
  private type!: string;
  private escalationRepository: EscalationRepositoryInterface;

  public async created(): Promise<void> {
    const escalationId = Number(this.$route.params.escalationId);
    const escalation = await this.escalationRepository.getEscalation(escalationId);
    this.type = escalation.chat ? 'chat' : 'ticket';
    this.loading = false;
  }
}
